import { PlusOutlined } from '@ant-design/icons';
import { Grid } from 'antd';
import { Button, ContentTopBar } from 'components';
import {
  PackageFilterFormPaginated,
  PackageFilterFormValues,
} from 'features/package/components/package-filter-form/type';
import { BookingViewTable } from 'features/report-master/booking-calculation/components/booking-table/booking-list';
import { BookingReportModal } from 'features/report-master/booking-calculation/components/modal/booking-report';
import { usePaginationParams } from 'hooks';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
const { useBreakpoint } = Grid;
const initialFilterValues: PackageFilterFormValues = {
  type_id: undefined,
  name: undefined,
  company_id: undefined,
};

export const BookingCalculationView = () => {
  const [data, setData] = useState<
    { total: number; items: any[] } | undefined
  >();
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const screens = useBreakpoint();

  const { params, updateParams } =
    usePaginationParams<PackageFilterFormPaginated>({
      page: 1,
      size: 10,
      ...initialFilterValues,
    });

  useEffect(() => {
    setIsLoading(true);
    fetch(
      `https://localhost:7046/api/FacilityRevenueContracts?page=${params.page}&size=${params.size}`,
    )
      .then((res) => {
        if (!res.ok) throw new Error('Network response was not ok');

        return res.json();
      })
      .then((jsonData) => {
        setData(jsonData);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error('Fetch error:', error);
        setIsLoading(false);
      });
  }, [params.page, params.size]);

  return (
    <>
      <ContentTopBar
        title={'Booking Report Rule'}
        // Uncomment and use buttons if needed
        renderButtons={
          <>
            <Button
              icon={!screens.xs ? <PlusOutlined /> : undefined}
              onClick={() => setShowAddUserModal(true)}
            >
              {'Add'}
            </Button>
            {showAddUserModal && (
              <BookingReportModal onClose={() => setShowAddUserModal(false)} />
            )}
          </>
        }
      />
      <BookingViewTable
        isLoading={isLoading}
        data={data}
        tableParams={params}
        updateParams={updateParams}
      />

      <Outlet />
    </>
  );
};
